import { authService } from '@/services/auth.js';

class HatLogout extends HTMLElement {
    private _unsubscribe: (() => void) | null = null;

    async connectedCallback() {
    this.renderLoading();

        this._unsubscribe = authService.subscribe((event) => {
            if (event.status === 'unauthenticated') {
                this.renderLoggedOut();
            }
        });

        try {
            await authService.signOut();
        } catch (err) {
            console.error('Logout failed', err);
            this.renderError();
        }
    }

    renderLoading() {
        this.innerHTML = `
            <style>
                .container {
                    min-height: 70vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 24px;
                    box-sizing: border-box;
                }

                .card {
                    width: 100%;
                    max-width: 420px;
                    background: rgba(255,255,255,0.92);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.35);
                    border-radius: 24px;
                    padding: 40px 32px;
                    box-shadow:
                        0 10px 40px rgba(0,0,0,0.18),
                        inset 0 1px 0 rgba(255,255,255,0.4);
                    text-align: center;
                }

                .spinner {
                    width: 54px;
                    height: 54px;
                    margin: 0 auto 24px;
                    border-radius: 50%;
                    border: 5px solid rgba(0,0,0,0.08);
                    border-top-color: #111;
                    animation: spin 0.8s linear infinite;
                }

                h1 {
                    margin: 0 0 10px;
                    font-size: 28px;
                    color: #111;
                }

                p {
                    margin: 0;
                    color: #666;
                    font-size: 15px;
                    line-height: 1.5;
                }

                @keyframes spin {
                    to {
                        transform: rotate(360deg);
                    }
                }
            </style>

            <div class="container">
                <div class="card">
                    <div class="spinner"></div>

                    <h1>Signing You Out</h1>

                    <p>
                        Ending your session securely...
                    </p>
                </div>
            </div>
        `;
    }

    renderLoggedOut() {
        this.innerHTML = `
            <style>
                .container {
                    min-height: 70vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 24px;
                    box-sizing: border-box;
                }

                .card {
                    width: 100%;
                    max-width: 460px;
                    background: rgba(255,255,255,0.92);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.35);
                    border-radius: 24px;
                    padding: 40px 32px;
                    box-shadow:
                        0 10px 40px rgba(0,0,0,0.18),
                        inset 0 1px 0 rgba(255,255,255,0.4);
                    text-align: center;
                }

                .icon {
                    width: 72px;
                    height: 72px;
                    margin: 0 auto 22px;
                    border-radius: 50%;
                    background: linear-gradient(
                        135deg,
                        #3bb273,
                        #2d8f5c
                    );
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 38px;
                    box-shadow:
                        0 8px 24px rgba(59,178,115,0.35);
                }

                h1 {
                    margin: 0 0 10px;
                    font-size: 30px;
                    color: #111;
                }

                p {
                    margin: 0 0 28px;
                    color: #666;
                    font-size: 15px;
                    line-height: 1.6;
                }

                .actions {
                    display: flex;
                    justify-content: center;
                }
            </style>

            <div class="container">
                <div class="card">

                    <div class="icon">
                        ✓
                    </div>

                    <h1>Logged Out</h1>

                    <p>
                        Your session has been securely ended.
                    </p>

                    <div class="actions">
                        <hat-nav-button href="/app">
                            Return to App
                        </hat-nav-button>
                    </div>

                </div>
            </div>
        `;
    }

    renderError() {
        this.innerHTML = `
            <style>
                .container {
                    min-height: 70vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 24px;
                }

                .card {
                    max-width: 420px;
                    background: white;
                    border-radius: 20px;
                    padding: 32px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.12);
                    text-align: center;
                }

                h1 {
                    margin-top: 0;
                    color: #b00020;
                }

                p {
                    color: #666;
                }
            </style>

            <div class="container">
                <div class="card">
                    <h1>Logout Failed</h1>

                    <p>
                        Something went wrong while signing you out.
                    </p>
                </div>
            </div>
        `;
    }

    disconnectedCallback() {
    this._unsubscribe?.();
    }
}

customElements.define('hat-logout', HatLogout);